<template>
	<div
		class="d-flex"
		:class="{ 'border-bottom': !isLast }"
		data-testid="new-member-experience-item"
	>
		<div class="col px-2 py-3">
			<div class="form-check">
				<input
					:id="`new-member-experience-${value.experienceId}`"
					v-model="value.selected"
					class="form-check-input"
					data-testid="new-member-experience-item-checkbox"
					type="checkbox"
					@change="onCheck"
				/>
				<label
					class="form-check-label fs-md"
					:for="`new-member-experience-${value.experienceId}`"
					data-testid="new-member-experience-item-label"
				>
					{{ value.title }}
				</label>
			</div>
			<BCollapse v-model="open" class="me-n5 me-md-0">
				<div class="pt-2 ps-3 small">
					<p class="mb-0" data-testid="new-member-experience-item-description">
						{{ value.description }}
					</p>
				</div>
			</BCollapse>
		</div>
		<div class="col-auto">
			<button
				class="px-2 py-3 lh-base d-inline-block align-top btn-reset"
				data-testid="new-member-experience-item-btn"
				@click="open = !open"
			>
				<ChevronUpIcon
					v-if="open"
					:height="12"
					:width="12"
					data-testid="new-member-experience-item-icon-up"
				/>
				<ChevronDownIcon
					v-else
					:height="12"
					:width="12"
					data-testid="new-member-experience-item-icon-down"
				/>
				<span class="visually-hidden">Show / Hide Content</span>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, type PropType, ref } from 'vue';
import { BCollapse } from 'bootstrap-vue-next';
import ChevronDownIcon from 'Lib/icons/ChevronDownIcon.vue';
import ChevronUpIcon from 'Lib/icons/ChevronUpIcon.vue';
import type { AemuiExperience } from 'Types/aemui/content-fragments/contentFragment';

const props = defineProps({
	modelValue: {
		type: Object as PropType<AemuiExperience>,
		default: () => {
			return {} as AemuiExperience;
		}
	},
	isLast: {
		type: Boolean,
		default: false
	}
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
	get: () => props.modelValue,
	set: (newValue: AemuiExperience) => {
		emit('update:modelValue', newValue);
	}
});

const onCheck = (e: Event) => {
	const target = e.target as HTMLInputElement;
	value.value = {
		...value.value,
		selected: target.checked
	};
};

const open = ref(false);

defineExpose({
	value
});
</script>
